export class Request {
  constructor(
    public id: number,
    public info: any,
    public text: string,
    public section: number
  ) {}
}
